import { DocumentType, CreateDocument } from '@/types/dashboard'
import { WalletOutlined, BankOutlined, FileTextOutlined, FilePdfOutlined } from '@ant-design/icons'

export const documentTypeOptions: DocumentType[] = [
  { key: 'expense', label: 'Expense Receipt', icon: '🧾' },
  { key: 'invoice', label: 'Sales Invoice', icon: '📄' },
  { key: 'bank', label: 'Bank Statement', icon: '🏦' },
  { key: 'bill', label: 'Supplier Bill', icon: '📋' },
  { key: 'payroll', label: 'Payroll Document', icon: '💰' },
  { key: 'other', label: 'Other Document', icon: '📁' }
]

export const documentUploadTypes: CreateDocument[] = [
  {
    title: 'Upload Expense Bills',
    description: 'Upload receipts and expense documents',
    icon: WalletOutlined,
    color: '#ff4d4f'
  },
  {
    title: 'Upload Bank Statements',
    description: 'Import bank statements for reconciliation',
    icon: BankOutlined,
    color: '#1890ff'
  },
  {
    title: 'Upload Sales Invoices',
    description: 'Import existing sales invoices',
    icon: FileTextOutlined,
    color: '#52c41a'
  }
]

export const createDocuments: CreateDocument[] = [
  {
    title: 'Create Sales Invoice',
    description: 'Generate new sales invoice',
    icon: FilePdfOutlined,
    color: '#722ed1'
  },
  {
    title: 'Create Quotation',
    description: 'Prepare quotation for customers',
    icon: FileTextOutlined,
    color: '#fa8c16'
  }
]